export default "__VITE_PUBLIC_ASSET__3e330cc0__"